// extracted by mini-css-extract-plugin
export var infoItem = "_q4-2";
export var title = "_q4-0";
export var value = "_q4-1";